export default "__VITE_ASSET__B7CbQ_DD__"